module.exports = __webpack_public_path__ + "media/dashboard/assets/images/hero/instagram-fourth-step-ec6b39f5e6e2fe61561e52847ebdd896.png";